export enum ApprovalStatusEnum {
  NotSet = 1,
  Pending = 2,
  ManualPending = 3,
  Approved = 4,
  Rejected = 5,
}
